'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _commonFunctions = require('../../helpers/commonFunctions');

function populateCoverageData(context, data) {
  context.updateProp('application.additional_data.policy_type', data.additional_data.policy_type);
  context.updateProp('application.additional_data.destination', data.additional_data.destination);
  context.updateProp('application.additional_data.deductible', data.additional_data.deductible);
  context.updateProp('application.additional_data.state', data.additional_data.state);
  context.updateProp('application.additional_data.membership_number', data.additional_data.membership_number);
  context.updateProp('application.additional_data.travelling_through_the_us', data.additional_data.travelling_through_the_us);
  context.updateProp('application.additional_data.number_of_travel_days_in_the_us', data.additional_data.number_of_travel_days_in_the_us);
  context.updateProp('application.additional_data.number_of_days_per_trip', data.additional_data.number_of_days_per_trip);
  context.updateProp('application.additional_data.coverage_length', data.additional_data.coverage_length);
  (0, _commonFunctions.populateEligibility)(context, data);
}

exports.default = function (context) {
  (0, _commonFunctions.populateQuoteData)(context, populateCoverageData);
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/transformers/oop/quote.js
// module id = 824
// module chunks = 0